<section class="container centered-card">
    <section class="error-container" *ngIf="internalError">
        <div class="error-container__icon mb-3">
            <img src="assets/images/icons/error 2.svg" alt="Error Icon">
        </div>
        <div class="error-container__content mb-3">
            <div class="error-container__content__status mb-2">Internal Server Error</div>
            <div class="error-container__content__message--weight400">
                <div class="mb-2">Oops! Something went wrong on our end. Please try again later. If the problem continues, contact our support team.</div>
            </div>
        </div>
        <div class="error-container__button">
            <button class="secondary-button" (click)="goback()">Back</button>
        </div>
    </section>
    <section class="error-container" *ngIf="error500">
        <div class="error-container__icon mb-3">
            <img src="assets/images/icons/error 2.svg" alt="Error Icon">
        </div>
        <div class="error-container__content mb-3">
            <div class="error-container__content__status mb-2">Internal Server Error</div>
            <div class="error-container__content__message--weight400">
                <div class="mb-2">Your Request has some technical issues.</div>
                <div class="mb-2">An incident is created and escalated to the Technical support team.</div>
                <div *ngIf="Id !== undefined"> Incident # : <span> <strong>{{ Id }}</strong></span> </div>
            </div>
        </div>
        <div class="error-container__button">
            <button class="secondary-button" (click)="goback()">Back</button>
        </div>
    </section>

    <section class="error-container" *ngIf="error403">
        <div class="error-container__icon mb-3">
            <img src="assets/images/icons/Vector.svg" alt="Vector Icon">
        </div>
        <div class="error-container__content mb-3">
            <div class="error-container__content__status mb-2">403 Access Denied</div>
            <div class="error-container__content__message--weight400 mb-2">
                You do not have the necessary permissions to view this content or access this resource.
            </div>
            <div class="error-container__content__message--weight600">
                Please contact the system admin for assistance.
            </div>
        </div>
        <div class="error-container__button">
            <button class="secondary-button" (click)="goback()">Back</button>
        </div>
    </section>

    <section class="error-container" *ngIf="error404">
        <div class="error-container__icon mb-3">
            <img src="assets/images/icons/error 2.svg" alt="Error Icon">
        </div>
        <div class="error-container__content mb-3">
            <div class="error-container__content__status mb-2">404 Not Found</div>
            <div class="error-container__content__message--weight400">
                Sorry, the page you are looking for does not exist.
            </div>
        </div>
        <div class="error-container__button">
            <button class="secondary-button" (click)="goback()">Back</button>
        </div>
    </section>

    <section class="error-container" *ngIf="error400">
        <div class="error-container__icon mb-3">
            <img src="assets/images/icons/bad request.svg" alt="Bad Request Icon">
        </div>

        <div class="error-container__content mb-3">
            <div class="error-container__content__status mb-2">400 Bad Request</div>
            <div class="error-container__content__message--weight400">
                Oops! There was a problem with your request.
            </div>
        </div>
        <div class="error-container__button">
            <button class="secondary-button" (click)="goback()">Back</button>
        </div>
    </section>

    <section *ngIf="error401" class="error-container">
        <div class="error-container__icon mb-3">
            <img src="assets/images/icons/unauthorized.svg" alt="Unauthorized Icon">
        </div>
        <div class="error-container__content mb-3">
            <div class="error-container__content__status mb-2">401 - Unauthorized</div>
            <div class="error-container__content__message--weight400 mb-2">
                <div class="mb-2">
                    You are not authorized to view this content.
                </div>
                <div>Please log in or provide valid credentials to access this resources.</div>
            </div>
            <div class="error-container__content__message--weight600">Click ‘OK’ to log in </div>
        </div>
        <div class="error-container__button">
            <button class="secondary-button" (click)="login()">OK</button>
        </div>
    </section>
</section>